<template>
    <div class="flex flex-col md:flex-row md:items-end w-full justify-between">
        <div class="style-emph ">
            {{ title }}
        </div>
        <div class="mt-4 md:mt-0">
            <div class="flex border border-blue-gray rounded-3xl pl-5 pr-5 py-1 py-2 items-center">
                <input @change="reloadItems" v-model="searchString" type="text" placeholder="Search with serial no."
                       class="w-full md:w-56 text-sm font-light bg-transparent outline-none"> <i
                    class="far fa-search text-blue-gray"></i>
            </div>
        </div>
    </div>

    <div class="bg-white shadow-100 rounded-xl mt-4">
        <div class="equipment-row grid-cols-1 md:grid-cols-10 items-center hidden md:grid py-3 px-7">
            <div class="style-title-1">
                ID
            </div>
            <div class="style-title-1 md:col-span-2">
                Type
            </div>
            <div class="style-title-1">
                Model
            </div>
            <div class="style-title-1 md:col-span-3">
                Location
            </div>
            <div class="style-title-1 md:col-span-2">
                Serial
            </div>
            <div></div>
        </div>
        <div v-for="equipment in equipments"
             class="equipment-row grid grid-cols-1 md:grid-cols-10 items-center py-5 px-7" :key="equipment.id">
            <div class="py-1 flex">
                <div class="style-title-1 w-1/4 text-right mr-3 md:hidden">
                    ID:
                </div>
                <div>
                    {{equipment.id}}
                </div>
            </div>
            <div class="py-1 flex md:col-span-2">
                <div class="style-title-1 w-1/4 text-right mr-3 md:hidden">
                    Type:
                </div>
                <div>
                    {{equipment.type}}
                </div>
            </div>

            <div class="py-1 flex">
                <div class="style-title-1 w-1/4 text-right mr-3 md:hidden">
                    Model:
                </div>
                <div>
                    {{equipment.model}}
                </div>
            </div>

            <div class="py-1 flex md:col-span-3">
                <div class="style-title-1 w-1/4 text-right mr-3 md:hidden">
                    Location:
                </div>
                <div>
                    {{equipment.location}}
                </div>
            </div>

            <div class="py-1 flex md:col-span-2">
                <div class="style-title-1 w-1/4 text-right mr-3 md:hidden">
                    Serial:
                </div>
                <div>
                    {{equipment.serial}}
                </div>
            </div>

            <div class="text-right mt-4 md:mt-0">
                <button
                    @click="() => select(equipment)"
                    class="btn btn--grid-select w-full md:w-auto ">
                    Select
                </button>
            </div>
        </div>
    </div>


    <div class="text-center mt-5" :class="{hidden: !loading}">
        <loading></loading>
    </div>

    <div class="text-center mt-8" :class="{hidden: !partial}">
        <a @click="loadMore" class="btn">Load More</a>
    </div>

</template>

<script charset="utf-8">

import Loading from './Loading.vue';
import Vuex from 'vuex';

export default {
    name: 'EquipmentGrid',
    props: ['title', 'toAddress'],
    data() {
        return {
            curPage: 0,
            loading: true,
            searchString: ''
        }
    },
    computed: {
        ...Vuex.mapGetters('equipments', {
            equipments: 'items',
            partial: 'partial'
        }),
    },
    created() {
        this.loadItems();
    },
    components: {
        Loading,
    },
    emits: ["select"],
    methods: {
        ...Vuex.mapActions('equipments', {
            getItems: 'getItems'
        }),
        loadMore(){
            this.curPage++;
            this.loadItems();
        },
        reloadItems(){
            this.curPage = 0;
            this.loadItems();
        },
        loadItems(){
            this.loading = true;
            let data = { page: this.curPage, searchString: this.searchString };
            if(this.$router.currentRoute.value.params.clientID){
                data.clientID = this.$router.currentRoute.value.params.clientID;
            }
            this.getItems(data).then(() => {
                this.loading = false;
            });
        },
        select(equipment) {
            this.$emit('select', equipment);
        }
    }
}
</script>
